import React, { useState, useEffect } from "react";
import axios from "axios";
import Navbar from "../components/Navbar"; // Import Navbar component

const getBaseURL = () => {
  if (window.location.hostname === "localhost") {
    return "http://localhost:5000/api"; // Local backend URL
  }
  return "https://joygardens-backend.onrender.com/api"; // Hosted backend URL
};

const BASE_URL = getBaseURL();

const UserEvents = () => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchEvents();
  }, []);

  const fetchEvents = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${BASE_URL}/events`);
      setEvents(response.data);
    } catch (err) {
      console.error("Error fetching events:", err);
      setError("Failed to load events. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-r from-blue-100 via-purple-100 to-blue-50 pt-24">
      <Navbar /> {/* Added Navbar */}
      <div className="container mx-auto py-8 px-4">
        <h1 className="text-4xl font-extrabold text-center text-indigo-700 mb-12">
          Upcoming Events
        </h1>
        {loading ? (
          <p className="text-center text-lg text-gray-700 animate-pulse">
            Loading events...
          </p>
        ) : error ? (
          <p className="text-center text-red-500 text-lg">{error}</p>
        ) : events.length === 0 ? (
          <p className="text-center text-lg text-gray-600">
            No events available at the moment.
          </p>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {events.map((event) => (
              <div
                key={event._id}
                className="bg-white shadow-lg rounded-lg overflow-hidden transition-transform transform hover:scale-105 hover:shadow-2xl"
              >
                {event.imageUrl && (
                  <img
                    src={event.imageUrl}
                    alt={event.title}
                    className="w-full h-56 object-cover"
                  />
                )}
                <div className="p-6">
                  <h2 className="text-2xl font-semibold text-indigo-800 mb-2">
                    {event.title}
                  </h2>
                  <p className="text-gray-700 mb-4">{event.description}</p>
                  <p className="text-sm text-gray-500">
                    {new Date(event.date).toLocaleDateString()}
                  </p>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default UserEvents;
